import CodeBlock from '@tiptap/extension-code-block';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ContentCodeBlockView } from './content-code-block-view';

export const ContentCodeBlock = CodeBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ContentCodeBlockView);
  },
  draggable: true,
});
